<template>
  <el-col :span="spanColumn">
    <div class="label">{{ label }}</div>
    <el-row style="margin-bottom: 0">
      <el-input
        v-model="displayValue"
        :placeholder="settings.placeholder"
        :class="['ancho_total', settings.inputClass]"
        :size="settings.size"
        :disabled="settings.disabled"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.enter="handleBlur"
        @keypress="filterInput"
      />
    </el-row>
    <!-- <div v-if="hint.text" :class="['hint', hint.type]">{{ hint.text }}</div> -->
  </el-col>
</template>

<script setup>
import {
  ref,
  computed,
  watch,
} from 'vue';

const props = defineProps({
  spanColumn: Number,
  label: String,
  settings: {
    type: Object,
    default: () => ({}),
  },
  modelValue: {
    type: Number,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue', 'blur']);

const settings = computed(() => ({
  placeholder: 'Valor en mm o fracción de pulgada (ej: 1/8)',
  inputClass: '',
  disabled: false,
  size: 'default',
  ...props.settings,
}));

const displayValue = ref(props.modelValue !== null ? String(props.modelValue) : '');
// const hint = ref({ text: '', type: '' });
const isFocused = ref(false);

watch(
  () => props.modelValue,
  (val) => {
    if (!isFocused.value) {
      displayValue.value = val !== null ? String(val) : '';
    }
  },
);

const filterInput = (event) => {
  if (!/[\d.,/]/.test(event.key)) {
    event.preventDefault();
  }
};

const handleFocus = () => {
  isFocused.value = true;
  // hint.value = { text: '', type: '' };
};

const handleBlur = () => {
  isFocused.value = false;
  const raw = displayValue.value.trim().replace(',', '.');

  if (!raw) {
    // hint.value = { text: '', type: '' };
    emit('update:modelValue', null);
    emit('blur');
    return;
  }

  if (raw.includes('/')) {
    const parts = raw.split('/');
    const num = parseFloat(parts[0]);
    const den = parseFloat(parts[1]);

    if (parts.length === 2 && !isNaN(num) && !isNaN(den) && den !== 0) {
      const mm = parseFloat(((num / den) * 25.4).toFixed(4));
      displayValue.value = String(mm);
      // hint.value = { text: `${raw}" → ${mm} mm`, type: 'success' };
      emit('update:modelValue', mm);
    } else {
      // hint.value = { text: 'Formato inválido. Use: numerador/denominador (ej: 1/8)', type: 'error' };
    }
  } else {
    const num = parseFloat(raw);
    if (!isNaN(num) && num > 0) {
      displayValue.value = String(num);
      // hint.value = { text: '', type: '' };
      emit('update:modelValue', num);
    } else {
      // hint.value = { text: 'Ingrese un valor mayor a 0', type: 'error' };
    }
  }

  emit('blur');
};
</script>

<style scoped>
.label {
  font-weight: 700;
  color: #111;
}

.ancho_total {
  width: 100%;
}

/* .hint {
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.4;
}

.hint.success {
  color: #67c23a;
  font-weight: 500;
}

.hint.error {
  color: #f56c6c;
} */
</style>
